module.exports = __webpack_public_path__ + "img/banner-princiapal.80029c44.png";